import { Client } from 'api/typegen/client/get';
import { GetLoanApplicationResponse } from 'api/typegen/client/application/get';
import { useEffect } from 'react';
import smartlookClient from 'smartlook-client';

const useSmartlook = () => {
  // Initialize SmartLook Client
  useEffect(() => {
    if (process.env.REACT_APP_SMARTLOOK_PROJECT_KEY) {
      smartlookClient.init(process.env.REACT_APP_SMARTLOOK_PROJECT_KEY);
    }
  }, []);

  const identifySmartlookClient = (
    loanApplication?: GetLoanApplicationResponse,
    client?: Client,
  ) => {
    if (client?.number) {
      smartlookClient.identify(client.number, {
        application_resolution: loanApplication?.resolution || '',
        application_resolution_detail: loanApplication?.resolutionDetail || '',
      });
    }
  };

  return { identifySmartlookClient };
};

export default useSmartlook;
